function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { createStore, applyMiddleware } from 'redux';
import { routerMiddleware, startListener } from 'redux-first-routing';
import createSagaMiddleware from 'redux-saga';
import createReduxWaitForMiddleware from 'redux-wait-for-action';
import includes from 'lodash/includes';
import keysIn from 'lodash/keysIn';
import forEach from 'lodash/forEach';
import packageInfo from '../../package.json';
import createReducer, { getCoreReducers } from './reducers';
// import createHelpers from './createHelpers';
// eslint-disable-next-line import/no-relative-packages
import createLogger from './logger';
const configureStore = (initialState, context, history)=>{
    // const helpers = createHelpers(helpersConfig);
    const sagaMiddleware = createSagaMiddleware();
    sagaMiddleware.setContext(context);
    const middleware = [
        routerMiddleware(history),
        sagaMiddleware,
        createReduxWaitForMiddleware()
    ];
    let enhancer;
    if (__DEV__) {
        middleware.push(createLogger());
        // https://github.com/zalmoxisus/redux-devtools-extension#14-using-in-production
        // eslint-disable-next-line global-require,@typescript-eslint/no-var-requires
        const { composeWithDevTools } = require('redux-devtools-extension/developmentOnly');
        const { name, version } = packageInfo;
        const composeEnhancers = composeWithDevTools({
            // Options: https://github.com/zalmoxisus/redux-devtools-extension/blob/master/docs/API/Arguments.md#options
            name: `${name}@${version}`,
            trace: true,
            traceLimit: 25,
            stateSanitizer: (state)=>_object_spread_props(_object_spread({}, state), {
                    notifications: _object_spread_props(_object_spread({}, state.notifications), {
                        notifications: `<<LIST OF NOTIFICATIONS: ${state.notifications.notifications.length}>>`
                    })
                })
        });
        // https://redux.js.org/docs/api/applyMiddleware.html
        enhancer = composeEnhancers(applyMiddleware(...middleware));
    } else {
        enhancer = applyMiddleware(...middleware);
    }
    // Because reducers are created dynamically shape of the state rendered by server,
    // which is final for route, is different core reducers expect. To avoid error we
    // create pseudo-reducers for initial store creation. In next step routes registering
    // own async reducers and overwrite initial pseudo-reducers.
    const initialReducers = {};
    const coreReducersKeys = keysIn(getCoreReducers());
    forEach(initialState, (state, key)=>{
        if (!includes(coreReducersKeys, key)) {
            initialReducers[key] = (initState = state)=>initState;
        }
        return state;
    });
    // See https://github.com/rackt/redux/releases/tag/v3.1.0
    const store = createStore(createReducer(initialReducers), initialState, enhancer);
    if (history) {
        startListener(history, store);
    }
    // Extensions
    store.runSaga = sagaMiddleware.run;
    store.asyncReducers = initialReducers; // Async reducer registry
    store.asyncSagas = []; // Async sagas registry
    // Hot reload reducers (requires Webpack or Browserify HMR to be enabled)
    if (__DEV__ && module.hot) {
        module.hot.accept('./reducers', ()=>store.replaceReducer(// eslint-disable-next-line global-require,@typescript-eslint/no-var-requires
            require('./reducers').default));
    }
    return store;
};
export default configureStore;
